import { render, staticRenderFns } from "./TheUpsertBrand.vue?vue&type=template&id=1ee46f8c"
import script from "./TheUpsertBrand.vue?vue&type=script&lang=ts"
export * from "./TheUpsertBrand.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports